<template>
  <div v-if="display">
    <strong>Level {{ upload.levelCount }} Values (must be unique):</strong>
    <ul>
      <li
        v-for="(item, index) in leafValues.slice(0,numItems)"
        :key="index"
      >
        {{ item }}
      </li>
      <li v-if="leafValues.length > numItems">
        ...
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { useUploadStore } from '@/store/admin/upload'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class DisplayNames extends Vue {
  numItems = 5
  upload = useUploadStore()

  get display () {
    return this.upload.levelsHelper.fieldForLevel(this.upload.levelCount)
  }

  get leafValues () {
    return this.upload.levelValues(this.upload.levelCount)
  }
}

</script>
